import { CheckIcon, Close } from '../../../../../../assets/icons';
import Button from '../../../../../button';

/**
 * Boutons de validation inline (sans footer)
 * @param {object} props
 * @param {function} props.onRefuse - Callback de refus
 * @param {function} props.onAccept - Callback d'acceptation
 * @param {string} props.refuseLabel - Libellé du bouton refuser (défaut: "Refuser")
 * @param {string} props.acceptLabel - Libellé du bouton accepter (défaut: "Accepter")
 * @param {boolean} props.isAcceptDisabled - Désactiver le bouton accepter
 * @param {boolean} props.showAccept - Show the accept button (default: true)
 * @param {boolean} props.showRefuse - Show the refuse button (default: true)
 */
const ValidationActions = ({ 
  onRefuse, 
  onAccept, 
  refuseLabel = "Refuser",
  acceptLabel = "Accepter",
  isAcceptDisabled = false,
  showAccept = true,
  showRefuse = true,
}) => {
  const handleRefuse = (e) => {
    e?.preventDefault?.();
    onRefuse?.();
  };

  const handleAccept = (e) => {
    e?.preventDefault?.();
    onAccept?.();
  };

  return (
    <div className="flex gap-2 mt-auto pt-4 justify-end">
      {showRefuse && (
        <Button size="LG" color="SECONDARY" onClick={handleRefuse}>
          <div className="flex gap-2">
            <div className="my-auto">
              <Close wh={20} color="#374151" />
            </div>
            <div className="my-auto">{refuseLabel}</div>
          </div>
        </Button>
      )}
      {showAccept && (
        <Button
          size="LG"
          color="PRIMARY"
          onClick={handleAccept}
          disabled={isAcceptDisabled}
        >
          <div className="flex gap-2">
            <div className="my-auto">
              <CheckIcon w={14} h={10} color="#ffff" />
            </div>
            <div className="my-auto">{acceptLabel}</div>
          </div>
        </Button>
      )}
    </div>
  );
};

export default ValidationActions;
